import React from 'react'
import { $Category } from './Middleware'
import { Input } from 'reactstrap';


export default class FilterImage extends React.Component {
    state = {
        cats: [],
        selected: '0'
    }
    componentDidMount() {
        $Category.getCategories().then(res => {
            const arr = [];
            arr.push({ cid: 0, cname: 'All' });
            arr.push(...res);
            this.setState({ cats: arr });
        })
    }
    handleChange = name => event => {
        this.setState({
            [name]: event.target.value
        })
        this.props.onselect(event.target.value)
    }
    render() {
        return (
            <Input bsSize="sm" type="select"
                value={this.state.selected}
                onChange={this.handleChange('selected')}>
                {
                    this.state.cats.map((cat, ind) => (
                        <option
                            key={ind}
                            value={cat.cid}
                        >{cat.cname}
                        </option>
                    ))
                }
            </Input>
        )
    }
}



// WEBPACK FOOTER //
// ./src/FilterImage.jsx